import { NO_COLOR } from "../../../constants.js";
function usePrettifyLabel(color, localeText, label) {
  if (label) return label;
  return color === NO_COLOR ? localeText.noColorLabel : prettifyHexColor(color);
}
function prettifyHexColor(hex) {
  return hex.startsWith("#") ? hex.substring(1) : hex;
}
export {
  usePrettifyLabel
};
//# sourceMappingURL=usePrettifyLabel.js.map
